<template>
  <div class="certificateTag">
    <certST ref="certST" :allTag="allTagST" @serviceStageTagList="onserviceStageTagList"/>
    <certPB ref="certPB" :allTag="allTagPB" @productAndBrandTagList="onproductAndBrandTagList"/>
    <div class="form-item">
      <span class="label"></span>
      <div class="input-box">
        <button class="btn-default" @click="prevStep">上一步</button>
        <button class="btn-primary" @click="save">下一步</button>
      </div>
    </div>
  </div>
</template>
<script>
import certST from "./certST.vue";
import certPB from "./certPB.vue";
import Bus from '@/scripts/bus.js'
import {mapState} from 'vuex'

import _ from 'lodash' 
export default {
  components: {
    "certST":certST,
    "certPB": certPB
  },
  data(){
    return{
      serviceAuthData:null,
      serviceStageTagList: [],
      productAndBrandTagList: [],
      respData: {
          ServiceStageTagList: [],
          ProductBrandTagList: []
      },
      allTagST: [],
      allTagPB: []
    }
  },
  watch: {
    serviceInfo(value){
      if(value){
        this.respData = {
          ServiceStageTagList: value.ServiceStageTagList,
          ProductBrandTagList: value.ProductBrandTagList,
        }
        this.defaultPB();
        this.defaultST();
      }
    }
  },
  computed: {
    ...mapState({
      secondProductList: state => state.secondProductList,
      serviceInfo: state=>state.serviceInfo
    })
  },
  mounted() {
    let that=this;
    Bus.$on('toServiceAuth2',function (params) {
      that.serviceAuthData=params;
    });
  },
  methods: {
        //上一步
    prevStep(){
      this.$emit('stepChange',2);
    },
    //下一步
    save(){
      if(this.allTagST) {
        this.$refs.certST.onSelectST();
      }
      if(this.allTagPB) {
        this.$refs.certPB.onSelectPB();
      }
      if(this.serviceStageTagList.length==0){
        this.$toast('请添加服务类型认证');
        return;
      }
      if(this.productAndBrandTagList.length==0){
        this.$toast('请添加产品品牌认证');
        return;
      }
      this.$emit('stepChange',4);
      let data = {
        serviceStageTagList: this.serviceStageTagList,
        productAndBrandTagList: this.productAndBrandTagList,
        ...this.serviceAuthData
      }
      Bus.$emit('toServiceAuth3',data);
    },
    onserviceStageTagList(list){
      this.serviceStageTagList = list;
    },
    onproductAndBrandTagList(list){
      this.productAndBrandTagList = list;
    },
    defaultPB() {
      let newArr = [];
      this.respData.ProductBrandTagList.map(resItem=>{
        this.secondProductList.map((sItem, sIndex)=>{
          let id1 = resItem.TwoProductId;
          if(id1 === sItem.ProductId) {
            //根据产品id分组，返回一个对象
            let product=_.groupBy(resItem.ProductTagList,'ThreeProductId');
            for (const kArr in product) {
              //对象的属性是不同产品的ID，
              let brandList  = product[kArr];
              let allTagText = brandList[0].ThreeProductName + "-";
              brandList.map(bItem=>{
                  allTagText += bItem.BrandName + "/"
              })
              let mmm = {
                chooseText: allTagText.slice(0,-1),
                chooseList: brandList,
                id1,
                id2: brandList[0].ThreeProductId,
                id2Name: brandList[0].ThreeProductName,
              }
              if(newArr[sIndex]) {
                newArr[sIndex] = newArr[sIndex].concat(mmm)
              }else {
                newArr[sIndex] = [mmm]
              }
            }
          }
        })
      })
      this.allTagPB = newArr; 
    },
    defaultST() {
      let newArr = [];
      this.respData.ServiceStageTagList.map(resItem=>{
        this.secondProductList.map((sItem, sIndex)=>{
          let id1 = resItem.TwoProductId;
          if(id1 === sItem.ProductId) {
            //根据产品id分组，返回一个对象
            let product=_.groupBy(resItem.ServiceStageTagList,'ThreeProductId');
            for (const kArr in product) {
              //对象的属性是不同产品的ID，
              let tagList  = product[kArr];
              let allTagText = tagList[0].ThreeProductName + "-";
              tagList.map(bItem=>{
                  allTagText += bItem.ServiceStageName + "/"
              })
              let mmm = {
                chooseText: allTagText.slice(0,-1),
                chooseList: tagList,
                id1,
                id2: tagList[0].ThreeProductId,
                id2Name: tagList[0].ThreeProductName,
              }
              if(newArr[sIndex]) {
                newArr[sIndex] = newArr[sIndex].concat(mmm)
              }else {
                newArr[sIndex] = [mmm]
              }
            }
          }
        })
      })
      this.allTagST = newArr; 
    }
  },
}
</script>
<style>
.btn-primary {
  display: inline-block;
}
</style>
